import router from '@/router'

export function handler (response) {
    return response.data
}

export function onError (error) {
    switch (error?.response?.status) {
        case 401: {
            router.push({
                name: 'Login',
                query: {
                    backRoute: location.pathname
                }
            })
            break
        }
    }
    return Promise.reject(error)
}
